module.exports = __webpack_public_path__ + "static/img/glxt_02.d705a2ea.png";